export default __webpack_public_path__ + "static/media/pokecenter.9d937111.png";